import React, { useState, useEffect } from "react";
import { Image, Row, Col } from "react-bootstrap";
import { isBrowser } from "react-device-detect";

//STYLES
import * as OrderDetailsItemStyles from "../../styles/orderDetailsItem";

function OrderDetailsItemFullPrice(props) {
    const [attention, setAttention] = useState(false);

    useEffect(() => {
        CheckAttention(props.item);
    }, []);

    function CheckAttention(item) {
        if (item.unReadMessages) {
            setAttention(true);
        }
    }

    const browserDisplay = (
        <div>
            <div style={OrderDetailsItemStyles.bodyWithoutPointer}>
                <Row>
                    <Col md="auto">
                        <Image
                            src={`/content/3dPrintingShop/products/${props.item.itemDetails.uuid.toString()}/${props.item.itemDetails.mainImage}`}
                            style={OrderDetailsItemStyles.image}
                        />
                    </Col>
                    <Col>
                        <Row>
                            <Col>
                                <strong>Name:</strong> {props.item.itemDetails.title} <br />
                                <strong>Quantity:</strong> {props.item.quantity} <br /> <br />
                                {props.item.customItem == "true" && (
                                    <div>
                                        <strong style={OrderDetailsItemStyles.customTitle}>Customisation</strong>
                                        {props.item.itemDetails.customItems.map((field, index) => {
                                            if (field.type == "text" || field.type == "dColour") {
                                                return (
                                                    <div key={index}>
                                                        {field.fieldName}: {field.fieldValue}
                                                    </div>
                                                );
                                            }
                                        })}
                                        {props.item.itemDetails.customColours && (
                                            <div>
                                                <br />
                                                <strong>Colours:</strong>
                                                {props.item.itemDetails.customItems.map((field, index) => {
                                                    if (field.type == "colour") {
                                                        return (
                                                            <div key={index}>
                                                                {field.fieldName}: {field.fieldValue}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Col>
                            <Col style={OrderDetailsItemStyles.middleColumn}>
                                {attention && (
                                    <div>
                                        <strong>Attention Needed </strong> - Please click this item or go to Printing Progress at the top
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col style={OrderDetailsItemStyles.columnRight}>
                                <strong>Price Per Item:</strong> £{(props.item.fullPriceWhenOrdered / 100).toFixed(2)} <br />
                                <strong>Total:</strong> £{((props.item.fullPriceWhenOrdered * props.item.quantity) / 100).toFixed(2)}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    );

    const mobileDisplay = (
        <div style={OrderDetailsItemStyles.mobile_itemBody}>
            <div style={OrderDetailsItemStyles.flexRow}>
                <div style={OrderDetailsItemStyles.mobile_imageContainer}>
                    <Image
                        src={`/content/3dPrintingShop/products/${props.item.itemDetails.uuid.toString()}/${props.item.itemDetails.mainImage}`}
                        style={OrderDetailsItemStyles.image}
                    />
                </div>
                <div style={OrderDetailsItemStyles.mobile_infoContainer}>
                    <div style={OrderDetailsItemStyles.mobile_orderRefs}>
                        <strong>Name:</strong> {props.item.itemDetails.title} <br />
                        <strong>Quantity:</strong> {props.item.quantity} <br /> <br />
                        {props.item.customItem == "true" && (
                            <div>
                                <strong style={OrderDetailsItemStyles.customTitle}>Customisation</strong>
                                {props.item.itemDetails.customItems.map((field, index) => {
                                    if (field.type == "text" || field.type == "dColour") {
                                        return (
                                            <div key={index}>
                                                {field.fieldName}: {field.fieldValue}
                                            </div>
                                        );
                                    }
                                })}
                                {props.item.itemDetails.customColours && (
                                    <div>
                                        <br />
                                        <strong>Colours:</strong>
                                        {props.item.itemDetails.customItems.map((field, index) => {
                                            if (field.type == "colour") {
                                                return (
                                                    <div key={index}>
                                                        {field.fieldName}: {field.fieldValue}
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <br />
                    <div style={OrderDetailsItemStyles.mobile_totals}>
                        <strong>Price Per Item:</strong> £{(props.item.fullPriceWhenOrdered / 100).toFixed(2)} <br />
                        <strong>Total:</strong> £{((props.item.fullPriceWhenOrdered * props.item.quantity) / 100).toFixed(2)}
                    </div>
                </div>
            </div>
            {attention && (
                <div style={OrderDetailsItemStyles.redText}>
                    <strong>Attention Needed </strong> - Please click this item or go to Printing Progress at the top
                </div>
            )}
        </div>
    );

    return (
        <div>
            {isBrowser ? browserDisplay : mobileDisplay}
            <br />
        </div>
    );
}

export default OrderDetailsItemFullPrice;
